import React, { Fragment, useState, useEffect } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
// import MySelect from '../common/select'
// import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import tools from "../../components/tools/tools";
// import FormEditarCarnet from './mesa_form_editar'
import Select from '../../components/select'

// Tipos y ocupaciones (copiados del item_carnet)
const TIPOS_OCUPACION = [
    { clave: "01", label: "01 - Cultivo, crianza y aprovechamiento", value: "01 - Cultivo, crianza y aprovechamiento" },
    { clave: "02", label: "02 - Extracción y suministro", value: "02 - Extracción y suministro" },
    { clave: "03", label: "03 - Construcción", value: "03 - Construcción" },
    { clave: "04", label: "04 - Tecnología", value: "04 - Tecnología" },
    { clave: "05", label: "05 - Procesos industriales", value: "05 - Procesos industriales" },
    { clave: "06", label: "06 - Transporte", value: "06 - Transporte" },
    { clave: "07", label: "07 - Provisión de bienes y servicios", value: "07 - Provisión de bienes y servicios" },
    { clave: "08", label: "08 - Gestión y soporte administrativo", value: "08 - Gestión y soporte administrativo" },
    { clave: "09", label: "09 - Salud y protección social", value: "09 - Salud y protección social" },
    { clave: "10", label: "10 - Comunicación", value: "10 - Comunicación" },
    { clave: "11", label: "11 - Desarrollo y extensión del conocimiento", value: "11 - Desarrollo y extensión del conocimiento" }
];

const OCUPACIONES = {
    "01": [
        { clave: "01.1", label: "01.1 - Agricultura y silvicultura", value: "01.1 - Agricultura y silvicultura" },
        { clave: "01.2", label: "01.2 - Ganadería", value: "01.2 - Ganadería" },
        { clave: "01.3", label: "01.3 - Pesca y acuacultura", value: "01.3 - Pesca y acuacultura" }
    ],
    "02": [
        { clave: "02.1", label: "02.1 - Exploración", value: "02.1 - Exploración" },
        { clave: "02.2", label: "02.2 - Extracción", value: "02.2 - Extracción" },
        { clave: "02.3", label: "02.3 - Refinición y beneficio", value: "02.3 - Refinición y beneficio" },
        { clave: "02.4", label: "02.4 - Provisión de energía", value: "02.4 - Provisión de energía" },
        { clave: "02.5", label: "02.5 - Provisión de agua", value: "02.5 - Provisión de agua" }
    ],
    "03": [
        { clave: "03.1", label: "03.1 - Planeación y dirección de obras", value: "03.1 - Planeación y dirección de obras" },
        { clave: "03.2", label: "03.2 - Edificación y urbanización", value: "03.2 - Edificación y urbanización" },
        { clave: "03.3", label: "03.3 - Acabado", value: "03.3 - Acabado" },
        { clave: "03.4", label: "03.4 - Instalación y mantenimiento", value: "03.4 - Instalación y mantenimiento" }
    ],
    "04": [
        { clave: "04.1", label: "04.1 - Mecánica", value: "04.1 - Mecánica" },
        { clave: "04.2", label: "04.2 - Electricidad", value: "04.2 - Electricidad" },
        { clave: "04.3", label: "04.3 - Electrónica", value: "04.3 - Electrónica" },
        { clave: "04.4", label: "04.4 - Informática", value: "04.4 - Informática" },
        { clave: "04.5", label: "04.5 - Telecomunicaciones", value: "04.5 - Telecomunicaciones" },
        { clave: "04.6", label: "04.6 - Procesos industriales", value: "04.6 - Procesos industriales" }
    ],
    "05": [
        { clave: "05.1", label: "05.1 - Procesamiento y fabricación", value: "05.1 - Procesamiento y fabricación" },
        { clave: "05.2", label: "05.2 - Minerales no metálicos", value: "05.2 - Minerales no metálicos" },
        { clave: "05.3", label: "05.3 - Metales", value: "05.3 - Metales" },
        { clave: "05.4", label: "05.4 - Alimentos y bebidas", value: "05.4 - Alimentos y bebidas" },
        { clave: "05.5", label: "05.5 - Textiles y prendas de vestir", value: "05.5 - Textiles y prendas de vestir" },
        { clave: "05.6", label: "05.6 - Materia orgánica", value: "05.6 - Materia orgánica" },
        { clave: "05.7", label: "05.7 - Productos químicos", value: "05.7 - Productos químicos" },
        { clave: "05.8", label: "05.8 - Productos metálicos y de hule y plástico", value: "05.8 - Productos metálicos y de hule y plástico" },
        { clave: "05.9", label: "05.9 - Productos eléctricos y electrónicos", value: "05.9 - Productos eléctricos y electrónicos" },
        { clave: "05.10", label: "05.10 - Productos impresos", value: "05.10 - Productos impresos" }
    ],
    "06": [
        { clave: "06.1", label: "06.1 - Ferroviario", value: "06.1 - Ferroviario" },
        { clave: "06.2", label: "06.2 - Autotransporte", value: "06.2 - Autotransporte" },
        { clave: "06.3", label: "06.3 - Aéreo", value: "06.3 - Aéreo" },
        { clave: "06.4", label: "06.4 - Marítimo y fluvial", value: "06.4 - Marítimo y fluvial" },
        { clave: "06.5", label: "06.5 - Servicios de apoyo", value: "06.5 - Servicios de apoyo" }
    ],
    "07": [
        { clave: "07.1", label: "07.1 - Comercio", value: "07.1 - Comercio" },
        { clave: "07.2", label: "07.2 - Alimentación y hospedaje", value: "07.2 - Alimentación y hospedaje" },
        { clave: "07.3", label: "07.3 - Turismo", value: "07.3 - Turismo" },
        { clave: "07.4", label: "07.4 - Deporte y esparcimiento", value: "07.4 - Deporte y esparcimiento" },
        { clave: "07.5", label: "07.5 - Servicios personales", value: "07.5 - Servicios personales" },
        { clave: "07.6", label: "07.6 - Reparación de artículos de uso doméstico y personal", value: "07.6 - Reparación de artículos de uso doméstico y personal" },
        { clave: "07.7", label: "07.7 - Limpieza", value: "07.7 - Limpieza" },
        { clave: "07.8", label: "07.8 - Servicio postal y mensajería", value: "07.8 - Servicio postal y mensajería" }
    ],
    "08": [
        { clave: "08.1", label: "08.1 - Bolsa, banca y seguros", value: "08.1 - Bolsa, banca y seguros" },
        { clave: "08.2", label: "08.2 - Administración", value: "08.2 - Administración" },
        { clave: "08.3", label: "08.3 - Servicios legales", value: "08.3 - Servicios legales" }
    ],
    "09": [
        { clave: "09.1", label: "09.1 - Servicios médicos", value: "09.1 - Servicios médicos" },
        { clave: "09.2", label: "09.2 - Inspección sanitaria y del medio ambiente", value: "09.2 - Inspección sanitaria y del medio ambiente" },
        { clave: "09.3", label: "09.3 - Seguridad social", value: "09.3 - Seguridad social" },
        { clave: "09.4", label: "09.4 - Protección de bienes y/o personas", value: "09.4 - Protección de bienes y/o personas" }
    ],
    "10": [
        { clave: "10.1", label: "10.1 - Publicación", value: "10.1 - Publicación" },
        { clave: "10.2", label: "10.2 - Radio, cine, televisión y teatro", value: "10.2 - Radio, cine, televisión y teatro" },
        { clave: "10.3", label: "10.3 - Interpretación artística", value: "10.3 - Interpretación artística" },
        { clave: "10.4", label: "10.4 - Traducción e interpretación lingüística", value: "10.4 - Traducción e interpretación lingüística" },
        { clave: "10.5", label: "10.5 - Publicidad, propaganda y relaciones públicas", value: "10.5 - Publicidad, propaganda y relaciones públicas" }
    ],
    "11": [
        { clave: "11.1", label: "11.1 - Investigación", value: "11.1 - Investigación" },
        { clave: "11.2", label: "11.2 - Enseñanza", value: "11.2 - Enseñanza" },
        { clave: "11.3", label: "11.3 - Difusión cultural", value: "11.3 - Difusión cultural" }
    ]
};

const Default = ({
    modal,
    setModal,
    setRefresh,
    selects
}) => {
    let { catalogos = [], listTipoCarnet = {}, idRegistro = 0 } = modal.datos
    const [selectCatalogo, setSelectCatalogo] = useState([])
    const [datos, setDatos] = useState({})
    
    // tools.getForm('formCarnetNuevo', { active: 1})
    const toggle = () => {
        if (setModal) {
            setModal((s) => ({...s, estado: !s.estado}))
        }
    }

    const onClickAgregar = () => {
    let carnetsIgnore = ['txtEsAnfitrion', 'listGenero', 'txtWhatsapp', 'txtCorreo', 'listGeneroSeg', 'txtWhatsappSeg', 'txtCorreoSeg', 'txtPuestoOtro', 'txtEmpresa']; // keep txtPuestoOtro for compatibility
        let formCarnetNuevo = tools.getForm('formCarnetNuevo', {ignore: carnetsIgnore})

        // If "Otro" is selected, validate txtPuestoOtro
        if (datos.listPuesto === 'Otro' && (!datos.txtPuestoOtro || datos.txtPuestoOtro.trim() === '')) {
            return tools.notie.alert({
                type: 'warning',
                text: 'Debes especificar el puesto cuando seleccionas "Otro"',
                time: 3,
                position: 'top'
            })
        }

        if(formCarnetNuevo.isEmtyCount){
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Faltan los siguientes campos (${formCarnetNuevo.isEmtyString})`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        }

        // Prepare data; ensure ocupacion fields are present
        let dataToSend = {
            ...formCarnetNuevo.data
        }

        console.log('formCarnetNuevo', dataToSend)

        fetch('/rt_mesaregistro_nuevo_carnet', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                idRc: idRegistro,
                listTipoCarnet: selects.listTipoCarnet.clave,
                formCarnets: [dataToSend]
            })
        })
        .then((response) => response.json())
        .then((response) => {
            console.log('respuestita',response)
            setRefresh((s) => !s)
            toggle()
            tools.notie.alert({
                type: 'success', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Carnet registrado correctamente.`,
                time: 2, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        })
        .catch((err) => {
            console.log(err)
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Detalle en el servidor, vuelva a intentar`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        })
    }

    useEffect(() => {
        let isS = true
        if (!datos.listTipoHospedaje) {
            return
        }
        // setSelectCatalogo(catalogos.catHotel.filter((v) => datos.listTipoHospedaje.split('-')[0] == v.TIPO_HHB))
        return () => isS = false
    }, [datos.listTipoHospedaje])

    return (
        <Fragment>
            <Modal
                className={`modal-body`}
                isOpen={modal.estado}
                toggle={toggle}
                centered={true}
                size={'lg'}
                style={{ maxWidth: '60em', width: '70%', padding: 0 }}
            >
                {/* <ModalHeader toggle={toggle}><div style={{ fontSize: 20 }}>Nuevo Carnet</div></ModalHeader> */}
                <div class="modal-header">
                    <h5 class="modal-title">
                        <div style={{fontSize: 20}}>Nuevo Carnet</div>
                    </h5>
                    <button type="button" class="close" aria-label="Close" onClick={() => toggle()} style={{ outline: "none", userSelect: "none" }}>
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <ModalBody>
                    <form className="col-md-12" id={`formCarnetNuevo`}>
                        <div className="row">
                            <div className="col-12 m-0 p-0">
                                {/* <div className="card"> */}
                                <div className="carnet-body">
                                    {/* {selects.listTipoCarnet.clave == 1?
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label
                                                    style={{ fontWeight: 600 }}
                                                    htmlFor="pcorreo"
                                                >
                                                    Tipo de carnet<span className="text-danger">*</span>
                                                </label>
                                                <Select
                                                    className="form-control form-control-md border border-dark"
                                                    // tipoValue={1}
                                                    data-label="Hospedaje"
                                                    placeholder="Seleccionar hospedaje"
                                                    id={`listTipoHospedaje`}
                                                    name="listTipoHospedaje"
                                                    datos={catalogos.catTipoHospedaje}
                                                    value={datos.listTipoHospedaje ? datos.listTipoHospedaje : ''}
                                                    onChange={({ item }) => {
                                                        setDatos((s) => ({ ...s, listTipoHospedaje: item.clave }))
                                                    }}
                                                />
                                                <span className={`text-danger txtVaciosItem listTipoHospedaje`} style={{ display: 'none' }}>Falta seleccionar Tipo de hospedaje</span>
                                            </div>
                                        </div>
                                        {datos.listTipoHospedaje == '1-1' || datos.listTipoHospedaje == '2-1' ?
                                            <Fragment>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label
                                                        style={{ fontWeight: 600 }}
                                                        htmlFor="pcorreo"
                                                    >
                                                        Selecciona un hotel<span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        className="form-control form-control-md border border-dark"
                                                        // tipoValue={1}
                                                        data-label="Hotel"
                                                        placeholder="Seleccionar hotel"
                                                        id={`listHotel`}
                                                        name="listHotel"
                                                        // datos={catalogos.catHotel}
                                                        datos={selectCatalogo}
                                                        value={datos.listHotel ? datos.listHotel : ''}
                                                        onChange={({ item }) => {
                                                            setDatos((s) => ({ ...s, listHotel: item.clave }))
                                                        }}
                                                    />
                                                    <span className={`text-danger txtVaciosItem listHotel`} style={{ display: 'none' }}>Falta seleccionar Hotel</span>
                                                </div> 
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label
                                                        style={{ fontWeight: 600 }}
                                                        htmlFor="Camas"
                                                    >
                                                        Camas<span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        className="form-control border border-dark"
                                                        type="number"
                                                        id='txtCamas'
                                                        name="txtCamas"
                                                        placeholder="Camas"
                                                        defaultValue={2}
                                                        value={datos.txtCamas}
                                                        onChange={(e) => {
                                                            e.persist()
                                                            setDatos((s) => ({ ...s, txtCamas: e.target.value }))
                                                        }}
                                                    />
                                                    <span className={`text-danger txtVaciosItem txtCamas`} style={{ display: 'none' }}>Falta completar (Camas)</span>
                                                </div>
                                            </div>
                                            </Fragment>
                                        : ''}
                                    </div>
                                    :''} */}
                                    <div className="row">
                                        <div className="col-12 mt-4 mb-2">
                                            <h5>Asistente 1</h5>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label
                                                    style={{ fontWeight: 600 }}
                                                    htmlFor="pnombre"
                                                >
                                                    Nombre(s)<span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    className="form-control border border-dark"
                                                    type="text"
                                                    id={`txtNombre`}
                                                    name="txtNombre"
                                                    placeholder="Nombre(s)"
                                                    value={datos.txtNombre ? datos.txtNombre : ''}
                                                    onChange={(e) => {
                                                        e.persist()
                                                        setDatos((s) => ({ ...s, txtNombre: e.target.value }))
                                                    }}
                                                />
                                                <span className={`text-danger txtVaciosItem txtNombre`} style={{ display: 'none' }}>Falta completar (Nombre(s))</span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label
                                                    style={{ fontWeight: 600 }}
                                                    htmlFor="papellidos"
                                                >
                                                    Apellidos<span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    className="form-control border border-dark"
                                                    id={`txtApellidos`}
                                                    name="txtApellidos"
                                                    type="text"
                                                    placeholder="Apellidos"
                                                    value={datos.txtApellidos ? datos.txtApellidos : ''}
                                                    onChange={(e) => {
                                                        e.persist()
                                                        setDatos((s) => ({ ...s, txtApellidos: e.target.value }))
                                                    }}
                                                />
                                                <span className={`text-danger txtVaciosItem txtApellidos`} style={{ display: 'none' }}>Falta completar Apellidos</span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label
                                                    style={{ fontWeight: 600 }}
                                                    htmlFor="pcorreo"
                                                >
                                                    Correo Electrónico
                                                </label>
                                                <input
                                                    className="form-control border border-dark"
                                                    id={`txtCorreo`}
                                                    name="txtCorreo"
                                                    type="text"
                                                    // onBlur={onClickBuscarCorreo}
                                                    placeholder="Correo Electrónico"
                                                    value={datos.txtCorreo ? datos.txtCorreo : ''}
                                                    onChange={(e) => {
                                                        e.persist()
                                                        setDatos((s) => ({ ...s, txtCorreo: e.target.value }))
                                                    }}
                                                />
                                                <span className={`text-danger txtVaciosItem txtCorreo`} style={{ display: 'none' }}>Falta completar Correo Electrónico</span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label
                                                    style={{ fontWeight: 600 }}
                                                    htmlFor="pcorreo"
                                                >
                                                    Género
                                                </label>
                                                <Select
                                                    className="form-control form-control-md border border-dark"
                                                    // tipoValue={1}
                                                    data-label="Género"
                                                    placeholder="Seleccionar Género"
                                                    id={`listGenero`}
                                                    name="listGenero"
                                                    datos={catalogos.catGenero}
                                                    value={datos.listGenero ? datos.listGenero : ''}
                                                    onChange={({ item }) => {
                                                        setDatos((s) => ({ ...s, listGenero: item.clave }))
                                                    }}
                                                />
                                                <span className={`text-danger txtVaciosItem listGenero`} style={{ display: 'none' }}>Falta completar Género</span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label
                                                    style={{ fontWeight: 600 }}
                                                    htmlFor="pcorreo"
                                                >
                                                    Whatsapp
                                                </label>
                                                <div className="input-group mb-2">
                                                    <div className="input-group-prepend border">
                                                        <div className="input-group-text"><i className="fa fa-whatsapp" aria-hidden="true"></i></div>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control border border-dark"
                                                        id={`txtWhatsapp`}
                                                        name="txtWhatsapp"
                                                        placeholder="Whatsapp"
                                                        value={datos.txtWhatsapp ? datos.txtWhatsapp : ''}
                                                        onChange={(e) => {
                                                            e.persist()
                                                            setDatos((s) => ({ ...s, txtWhatsapp: e.target.value }))
                                                        }}
                                                    />
                                                </div>
                                                <span className={`text-danger txtVaciosItem txtWhatsapp`} style={{ display: 'none' }}>Falta completar Whatsapp</span>
                                                {/* <PhoneInput
                                            name='txtWhatsapp'
                                            className={'border border-dark'}
                                            value={datos.txtWhatsapp}
                                            code={datos.txtWhatsappCode}
                                            iso={datos.txtWhatsappPais}
                                            label='Whatsapp'
                                            onChange={(datos) => {
                                                setDatos((s) => ({
                                                    ...s,
                                                    txtWhatsapp: datos.number,
                                                    txtWhatsappCode: datos.code,
                                                    txtWhatsappPais: datos.iso,
                                                }));
                                            }}
                                        /> */}
                                            </div>
                                        </div>
                                        {/* CURP y RFC */}
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label
                                                    style={{ fontWeight: 600 }}
                                                    htmlFor={`txtCurp`}
                                                >
                                                    CURP
                                                </label>
                                                <input
                                                    className="form-control border border-dark"
                                                    type="text"
                                                    id={`txtCurp`}
                                                    name="txtCurp"
                                                    placeholder="CURP"
                                                    maxLength={18}
                                                    value={datos.txtCurp || ''}
                                                    onChange={(e) => {
                                                        const value = e.target.value.toUpperCase().slice(0, 18);
                                                        setDatos((s) => ({ ...s, txtCurp: value }));
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label
                                                    style={{ fontWeight: 600 }}
                                                    htmlFor={`txtRfc`}
                                                >
                                                    RFC
                                                </label>
                                                <input
                                                    className="form-control border border-dark"
                                                    type="text"
                                                    id={`txtRfc`}
                                                    name="txtRfc"
                                                    placeholder="RFC"
                                                    maxLength={13}
                                                    value={datos.txtRfc || ''}
                                                    onChange={(e) => {
                                                        const value = e.target.value.toUpperCase().slice(0, 13);
                                                        setDatos((s) => ({ ...s, txtRfc: value }));
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Tipo de ocupación */}
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label style={{ fontWeight: 600 }} htmlFor={`listTipoOcupacion`}>
                                                    Tipo de ocupación
                                                </label>
                                                <Select
                                                    className="form-control form-control-md border border-dark"
                                                    data-label="Tipo de ocupación"
                                                    placeholder="Seleccionar tipo de ocupación"
                                                    id={`listTipoOcupacion`}
                                                    name="listTipoOcupacion"
                                                    datos={TIPOS_OCUPACION}
                                                    value={datos.listTipoOcupacion || ''}
                                                    onChange={({ item }) => {
                                                        setDatos((s) => ({ ...s, listTipoOcupacion: item.clave, listOcupacion: '' }));
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Ocupación */}
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label style={{ fontWeight: 600 }} htmlFor={`listOcupacion`}>
                                                    Ocupación
                                                </label>
                                                <Select
                                                    className="form-control form-control-md border border-dark"
                                                    data-label="Ocupación"
                                                    placeholder={datos.listTipoOcupacion ? "Seleccionar ocupación" : "Primero selecciona tipo de ocupación"}
                                                    id={`listOcupacion`}
                                                    name="listOcupacion"
                                                    datos={datos.listTipoOcupacion ? (OCUPACIONES[datos.listTipoOcupacion] || []) : []}
                                                    includeDataValue={true}
                                                    value={datos.listOcupacion || ''}
                                                    disabled={!(datos.listTipoOcupacion)}
                                                    onChange={({ item }) => {
                                                        setDatos((s) => ({ ...s, listOcupacion: item.clave }));
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label
                                                    style={{ fontWeight: 600 }}
                                                    htmlFor="txtEmpresa"
                                                >
                                                    Nombre de la empresa/institución<span className="text-danger"></span>
                                                </label>
                                                <input
                                                    className="form-control border border-dark"
                                                    type="text"
                                                    id="txtEmpresa"
                                                    name="txtEmpresa"
                                                    placeholder="Nombre de la empresa/institución"
                                                    maxLength={250}
                                                    value={datos.txtEmpresa || ''}
                                                    onChange={(e) => {
                                                        e.persist();
                                                        const value = e.target.value;
                                                        setDatos((s) => ({ ...s, txtEmpresa: value }));
                                                    }}
                                                />
                                                <span className={`text-danger txtVaciosItem txtEmpresa`} style={{ display: 'none' }}>Falta completar Nombre de la empresa/institución</span>
                                            </div>
                                        </div>
                                        {(listTipoCarnet.clave == '3') ?
                                            <Fragment>
                                                {/* <div className="col-md-6">
                                                <div className="form-group">
                                                    <label
                                                        style={{ fontWeight: 600 }}
                                                        htmlFor="Puesto"
                                                    >
                                                        Puesto<span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        className="form-control border border-dark"
                                                        id={`txtPuesto${indice + 1}`}
                                                        name="txtPuesto"
                                                        type="text"
                                                        placeholder="Puesto"
                                                        value={datos.txtPuesto ? datos.txtPuesto : ''}
                                                        onChange={(e) => {
                                                            e.persist()
                                                            setDatos((s) => ({ ...s, txtPuesto: e.target.value }))
                                                        }}
                                                    />
                                                    <span className={`text-danger txtVaciosItem${indice + 1} txtPuesto${indice + 1}`} style={{ display: 'none' }}>Falta completar Puesto</span>
                                                </div>
                                            </div> */}
                                                {/* <div className="col-md-6">
                                                <div className="form-group">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input border-dark"
                                                            id={`txtEsAnfitrion${indice + 1}`}
                                                            name="txtEsAnfitrion"
                                                            type="checkbox"
                                                            placeholder="Es Anfitrion"
                                                            checked={datos.txtEsAnfitrion ? true : false}
                                                            // value={datos.txtEsAnfitrion? 1: 0}
                                                            // {...(datos.txtEsAnfitrion? checked: '')}
                                                            onChange={(e) => {
                                                                e.persist()
                                                                setDatos((s) => ({ ...s, txtEsAnfitrion: !s.txtEsAnfitrion }))
                                                            }}
                                                        />
                                                        <label className="form-check-label" htmlFor="flexCheckDefault" style={{ fontWeight: 600 }}>
                                                            Es Anfitrion<span className="text-danger">*</span>
                                                        </label>
                                                        <span className={`text-danger txtVaciosItem${indice + 1} txtEsAnfitrion${indice + 1}`} style={{ display: 'none' }}>Falta completar Anfitrion</span>
                                                    </div>
                                                </div>
                                            </div> */}
                                            </Fragment>
                                            : ''}
                                    </div>
                                    {datos.listTipoHospedaje == '2-0' || datos.listTipoHospedaje == '2-1' ?
                                        <Fragment>
                                            <div className="row">
                                                <div className="col-12 mt-4 mb-2">
                                                    <h5>Asistente 2</h5>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            style={{ fontWeight: 600 }}
                                                            htmlFor="pnombre"
                                                        >
                                                            Nombre(s)<span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            className="form-control border border-dark"
                                                            type="text"
                                                            id={`txtNombreSeg`}
                                                            name="txtNombreSeg"
                                                            placeholder="Nombre(s)"
                                                            value={datos.txtNombreSeg ? datos.txtNombreSeg : ''}
                                                            onChange={(e) => {
                                                                e.persist()
                                                                setDatos((s) => ({ ...s, txtNombreSeg: e.target.value }))
                                                            }}
                                                        />
                                                        <span className={`text-danger txtVaciosItem txtNombreSeg`} style={{ display: 'none' }}>Falta completar (Nombre(s))</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            style={{ fontWeight: 600 }}
                                                            htmlFor="papellidos"
                                                        >
                                                            Apellidos<span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            className="form-control border border-dark"
                                                            id={`txtApellidosSeg`}
                                                            name="txtApellidosSeg"
                                                            type="text"
                                                            placeholder="Apellidos"
                                                            value={datos.txtApellidosSeg ? datos.txtApellidosSeg : ''}
                                                            onChange={(e) => {
                                                                e.persist()
                                                                setDatos((s) => ({ ...s, txtApellidosSeg: e.target.value }))
                                                            }}
                                                        />
                                                        <span className={`text-danger txtVaciosItem txtApellidosSeg`} style={{ display: 'none' }}>Falta completar Apellidos</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            style={{ fontWeight: 600 }}
                                                            htmlFor="pcorreo"
                                                        >
                                                            Correo Electrónico
                                                        </label>
                                                        <input
                                                            className="form-control border border-dark"
                                                            id={`txtCorreoSeg`}
                                                            name="txtCorreoSeg"
                                                            type="text"
                                                            // onBlur={onClickBuscarCorreo}
                                                            placeholder="Correo Electrónico"
                                                            value={datos.txtCorreoSeg ? datos.txtCorreoSeg : ''}
                                                            onChange={(e) => {
                                                                e.persist()
                                                                setDatos((s) => ({ ...s, txtCorreoSeg: e.target.value }))
                                                            }}
                                                        />
                                                        <span className={`text-danger txtVaciosItem txtCorreoSeg`} style={{ display: 'none' }}>Falta completar Correo Electrónico</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            style={{ fontWeight: 600 }}
                                                            htmlFor="pcorreo"
                                                        >
                                                            Género
                                                        </label>
                                                        <Select
                                                            className="form-control form-control-md border border-dark"
                                                            // tipoValue={1}
                                                            data-label="Género"
                                                            placeholder="Seleccionar Género"
                                                            id={`listGeneroSeg`}
                                                            name="listGeneroSeg"
                                                            datos={catalogos.catGenero}
                                                            value={datos.listGeneroSeg ? datos.listGeneroSeg : ''}
                                                            onChange={({ item }) => {
                                                                setDatos((s) => ({ ...s, listGeneroSeg: item.clave }))
                                                            }}
                                                        />
                                                        <span className={`text-danger txtVaciosItem listGeneroSeg`} style={{ display: 'none' }}>Falta completar Género</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            style={{ fontWeight: 600 }}
                                                            htmlFor="pcorreo"
                                                        >
                                                            Whatsapp
                                                        </label>
                                                        <div className="input-group mb-2">
                                                            <div className="input-group-prepend border">
                                                                <div className="input-group-text"><i className="fa fa-whatsapp" aria-hidden="true"></i></div>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                className="form-control border border-dark"
                                                                id={`txtWhatsappSeg`}
                                                                name="txtWhatsappSeg"
                                                                placeholder="Whatsapp"
                                                                value={datos.txtWhatsappSeg ? datos.txtWhatsappSeg : ''}
                                                                onChange={(e) => {
                                                                    e.persist()
                                                                    setDatos((s) => ({ ...s, txtWhatsappSeg: e.target.value }))
                                                                }}
                                                            />
                                                        </div>
                                                        <span className={`text-danger txtVaciosItem txtWhatsappSeg`} style={{ display: 'none' }}>Falta completar Whatsapp</span>
                                                    </div>
                                                </div>
                                                {(listTipoCarnet.clave == '3') ?
                                                    <Fragment>
                                                        {/* <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label
                                                                style={{ fontWeight: 600 }}
                                                                htmlFor="Puesto"
                                                            >
                                                                Puesto
                                                            </label>
                                                            <input
                                                                className="form-control border border-dark"
                                                                id={`txtPuestoSeg${indice + 1}`}
                                                                name="txtPuestoSeg"
                                                                type="text"
                                                                placeholder="Puesto"
                                                                value={datos.txtPuestoSeg ? datos.txtPuestoSeg : ''}
                                                                onChange={(e) => {
                                                                    e.persist()
                                                                    setDatos((s) => ({ ...s, txtPuestoSeg: e.target.value }))
                                                                }}
                                                            />
                                                            <span className={`text-danger txtVaciosItem${indice + 1} txtPuestoSeg${indice + 1}`} style={{ display: 'none' }}>Falta completar Puesto</span>
                                                        </div>
                                                    </div> */}
                                                        {/* <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input border-dark"
                                                        id={`txtEsAnfitrion${indice + 1}`} 
                                                        name="txtEsAnfitrion"
                                                        type="checkbox"
                                                        placeholder="Es Anfitrion"
                                                        checked={datos.txtEsAnfitrion? true: false}
                                                        // value={datos.txtEsAnfitrion? 1: 0}
                                                        // {...(datos.txtEsAnfitrion? checked: '')}
                                                        onChange={(e) => {
                                                            e.persist()
                                                            setDatos((s) => ({ ...s, txtEsAnfitrion: !s.txtEsAnfitrion }))
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor="flexCheckDefault"  style={{ fontWeight: 600 }}>
                                                        Es Anfitrion<span className="text-danger">*</span>
                                                    </label>
                                                    <span className={`text-danger txtVaciosItem${indice + 1} txtEsAnfitrion${indice + 1}`} style={{display: 'none'}}>Falta completar Anfitrion</span>  
                                                </div>
                                            </div>
                                        </div> */}
                                                    </Fragment>
                                                    : ''}
                                            </div>
                                        </Fragment>
                                        : ''}
                                    {/* {datos.listTipoHospedaje == '1-1' || datos.listTipoHospedaje == '2-1' ?
                                        <Fragment>
                                            <div className="row mt-5">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            style={{ fontWeight: 600 }}
                                                            htmlFor="pnombre"
                                                        >
                                                            Fecha de entrada<span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            className="form-control border border-dark"
                                                            type="date"
                                                            id={`txtFechaInicio`}
                                                            name="txtFechaInicio"
                                                            placeholder="Nombre(s)"
                                                            value={datos.txtFechaInicio ? datos.txtFechaInicio : ''}
                                                            onChange={(e) => {
                                                                e.persist()
                                                                setDatos((s) => ({ ...s, txtFechaInicio: e.target.value }))
                                                            }}
                                                        />
                                                        <span className={`text-danger txtVaciosItem txtFechaInicio`} style={{ display: 'none' }}>Falta completar (Nombre(s))</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label
                                                            style={{ fontWeight: 600 }}
                                                            htmlFor="pnombre"
                                                        >
                                                            Fecha de salida<span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            className="form-control border border-dark"
                                                            type="date"
                                                            id={`txtFechaFin`}
                                                            name="txtFechaFin"
                                                            placeholder="Nombre(s)"
                                                            value={datos.txtFechaFin ? datos.txtFechaFin : ''}
                                                            onChange={(e) => {
                                                                e.persist()
                                                                setDatos((s) => ({ ...s, txtFechaFin: e.target.value }))
                                                            }}
                                                        />
                                                        <span className={`text-danger txtVaciosItem txtFechaFin`} style={{ display: 'none' }}>Falta completar (Nombre(s))</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Fragment>
                                        : ''} */}
                                </div>
                            </div>
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={() => onClickAgregar()}
                    >Guardar</Button>
                    <Button
                        color="danger"
                        onClick={toggle}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    )
}

export default Default